import type { CompanySummary, Paginated } from '@obras/shared';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { api, queryString } from '../../lib/api.js';

export const empresaKeys = {
  all: ['empresas'] as const,
  porCnpj: (cnpj: string) => ['empresas', 'por-cnpj', cnpj] as const,
};

/**
 * A empresa do órgão com este CNPJ, se existir.
 *
 * É o que o formulário consulta antes de cadastrar: encontrada, a tela oferece
 * a empresa que já existe em vez de deixar criar a segunda. `null` desliga a
 * consulta — enquanto o CNPJ está incompleto, não há o que perguntar.
 */
export function useCompanyByCnpj(cnpj: string | null) {
  return useQuery({
    queryKey: empresaKeys.porCnpj(cnpj ?? ''),
    queryFn: async ({ signal }) => {
      const pagina = await api.get<Paginated<CompanySummary>>(
        `/empresas${queryString({ cnpj, perPage: 1 })}`,
        signal,
      );
      return pagina.items[0] ?? null;
    },
    enabled: cnpj !== null,
    staleTime: 60 * 1000,
  });
}

export function useDeleteCompany() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => api.delete<void>(`/empresas/${id}`),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: empresaKeys.all }),
  });
}
